import { kakaotalkEscapeUrl } from '@/constants/url';

const getKakaoEscapeUrl = (url: string) => {
  return `${kakaotalkEscapeUrl}?url=${url}`;
};

export default getKakaoEscapeUrl;
